import script from "./ActivityShare.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityShare.vue?vue&type=script&setup=true&lang=js"

import "./ActivityShare.vue?vue&type=style&index=0&id=e8de7dea&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8de7dea"]])

export default __exports__